<template>
    <div class="famous-form-read-web">
        <!-- 1. tab部分 -->
        <div class="famous-form-rw-tab dsp-flex">
            <div class="famous-pedia-cf-tab-item" @click="toggleTab(1)">
                <span class="famous-pcti-title" v-bind:class="{'cur': curPediaContentTab == 1}"><span class="big-title">生平事迹</span></span>
            </div>
            <div class="famous-pedia-cf-tab-item" @click="toggleTab(2)">
                <span class="famous-pcti-title" v-bind:class="{'cur': curPediaContentTab == 2}"><span class="big-title">批盘讨论</span><span class="small-title" v-if="curPediaBaziInfo.reply != 0">{{curPediaBaziInfo.reply}}人</span></span>
            </div>
        </div>
        <!-- 2. 主要内容部分 -->
        <famous-life-story-web
            v-if="curPediaContentTab == 1">
        </famous-life-story-web>
        <famous-comment-list-web class="famous-comment-list-web"
            v-if="curPediaContentTab == 2">
        </famous-comment-list-web>
    </div>
</template>

<script>
import FamousLifeStoryWeb from '../../layouts/famouspediaweb/FamousLifeStoryWeb.vue'
import FamousCommentListWeb from '../../layouts/famouspediaweb/FamousCommentListWeb.vue'
import { DOM, FAMOUS_DOM } from '../../modules/dom';
export default {
    name: 'FamousFormReadWeb',
    components: { FamousLifeStoryWeb, FamousCommentListWeb },
    computed: {
        curPediaContentTab() {
            return this.$store.state.famouspedia.curPediaContentTab;
        },
        curPediaBaziInfo() {
            return this.$store.state.famouspedia.curPediaBaziInfo;
        }
    },
    mounted() {
        var me = this;
        setTimeout(() => {
            FAMOUS_DOM.bindFamousFormScrollEvent(true);
        }, 1000);
    },
    methods: {
        toggleTab(tab) {
            // 重复点击return一下
            if(tab == this.$store.state.famouspedia.curPediaContentTab) {
                return;
            }
            this.$store.state.famouspedia.curPediaContentTab = tab;
            FAMOUS_DOM.bindFamousFormScrollEvent(false);
            setTimeout(() => {
                FAMOUS_DOM.bindFamousFormScrollEvent(true);
            }, 1000);
            
            // var curScrollYId = this.$store.state.minifatefortune.curScrollYId;
            setTimeout(() => {
                if(tab == 1) {
                    FAMOUS_DOM.updateFamousReadStoryScrollTop('');
                }else if(tab == 2) {
                    FAMOUS_DOM.updateFamousReadCommentScrollTop('');
                }
            }, 20);

            var baikeId = this.$store.state.famouspedia.curPediaBaziId;
            if(tab == 2) {
                this.$store.dispatch('famouspediacomment/setCommentFormData', {
                    formData: {
                        bid: baikeId,
                        f_type: 'all',
                        parentsid: 0,
                        touid: 0
                    }
                })
            }
        }
    }
}
</script>